    // Map question text and survey question text should be translated within appConfig.js
    // Do not edit text within curly brackets, ie: {abc}
    // Format: "<ComponentName>.<Description>": "<Text>"

    module.exports = ({
        "polyline": "Rota",
        "icon": "Marcador",
        "polygon": "Polígono",

        // (optional) {branch_name} can be used to display the branch display name in the document title
        "DocumentTitle.map_page": "{branch_name} | Mapa",
        "DocumentTitle.error_page": "{branch_name} | Erro",
        "DocumentTitle.end_page": "{branch_name} | Terminar",
        "DocumentTitle.intro_modal": "{branch_name} | Introdução",
        "DocumentTitle.info_modal": "{branch_name} | Informações",
        "DocumentTitle.survey_modal": "{branch_name} | Pesquisa",

        "Landing.header": "Benvind@s!",
        "Landing.main_copy": "Utilize essa ferramenta para nos dizer como você interage com seu campus/distrito e ajude-nos a entender possibilidades para esse lugar.",
        "Landing.back_to_map": "De volta ao mapa",
        "Landing.start_answering": "Vamos Começar",
        "Landing.data.header": "Uso de dados",
        "Landing.data.copy": "Nós protegemos sua privacidade e todos os dados somente serão utlizados internamente para fins desta pesquisa.",
        "Landing.help.header": "Instruções",
        "Landing.help.copy": "No mapa, você pode criar pontos, linhas e áreas para descrever seu local. Você pode fazer uma busca por um local, e o mapa pode ser navegado e utilizado em modo mapa ou satélite.",
        "Landing.feedback": "Envie-nos seu feedback",

        "MapContainer.continue": "Continue",
        "MapContainer.back_button": "De Volta ao Mapa",
        "MapContainer.info_button": "Instruções",
        "MapContainer.finish_button": "Terminei o Mapa",
        "MapContainer.submit": "Enviar",
        "MapContainer.mapButtonInfo": "Zoom para Local",
        "MapContainer.roadmap": "Mapa",
        "MapContainer.satellite": "Satélite",


        "CancelButton.text": "Cancelar",

        "IconDrawer.expand_drawer": "Expandir",
        "IconDrawer.instructions": "Desenhar",

        "LayerToggle.roadmap": "Mapa",
        "LayerToggle.satellite": "Satélite",

        "ConfirmationPopup.done": "Concluído",
        "ConfirmationPopup.cancel": "Cancelar",

        "PolygonDraw.default_message": "Clique em qualquer lugar para começar a desenhar sua área.",
        "PolygonDraw.alternative_message": "Desenhe pontos para redimensionar sua área.",

        "PolylineDraw.default_message": "Clique em qualquer lugar para começar a desenhar sua linha.",
        "PolylineDraw.alternative_message": "Desenhe pontos para redimensionar sua linha.",

        "IconDrop.default_message": "Clique em qualquer lugar para adicionar um ícone.",
        "IconDrop.alternative_message": "Arraste o ícone para mudar sua localização.",

        "EditModal.delete": "Apagar",
        "EditModal.save": "Salvar",
        "EditModal.cancel": "Cancelar",
        "EditModal.textarea_placeholder": "Diga mais ou clique para salvar.",
        "EditModal.addTitle": "Adicione seu {icon_type}",
        "EditModal.editTitle": "Modifique seu {icon_type}",
        "EditModal.reactionTitle": "Sua experiência aqui é positiva ou negativa?.",
        "EditModal.starRatingTitle": "Como você qualificaria sua experiência aqui?",
        "EditModal.commentTitle": "Algo Mais?",
        "EditModal.deleteConfirmation": "Você tem certeza?",
        "EditModal.deleteConfirmationText": "Remover isso {icon_type} não pode ser desfeito.",

        "SearchBox.placeholder": "Buscar por Local",

        "Survey.submitting": "Enviando...",

        "EndLanding.header": "Obrigado",
        "EndLanding.copy": "Término cópia",
        "EndLanding.take_again": "Compartilhe mais sobre seu local -- Reiniciar!",
    });



// WEBPACK FOOTER //
// ./src/locales/pt-PT.js